import { Text, Badge, Inline } from 'braid-design-system';
import type React from 'react';

import { ListingStatus } from 'src/generated/graphql';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

interface TitleStatusProps {
  listing: ClientListingForListingsTab;
}

export const TitleStatus = ({ listing }: TitleStatusProps) => {
  const isPosted =
    listing.status === ListingStatus.Active ||
    listing.status === ListingStatus.Pending;
  const isBoosted = listing.isPremium || listing.isListingEmailBoosted;

  // Ensure the listing is posted otherwise it would render "Boosted" when they're expired...
  if (isPosted && isBoosted) {
    if (listing.isPremium && listing.isListingEmailBoosted) {
      return (
        <Inline space="xxsmall">
          <Badge weight="strong" tone="info">
            Website Search Boost
          </Badge>
          <Badge weight="strong" tone="info">
            Email Boost
          </Badge>
        </Inline>
      );
    } else if (listing.isPremium) {
      return (
        <Badge weight="strong" tone="info">
          Website Search Boost
        </Badge>
      );
    }
    return (
      <Badge weight="strong" tone="info">
        Email Boost
      </Badge>
    );
  }

  let listingStatus;

  if (listing.status === ListingStatus.Unknown) {
    listingStatus = ListingStatus.Draft;
  } else if (listing.status === ListingStatus.Expired) {
    listingStatus = 'Removed';
  } else {
    listingStatus = ListingStatus[listing.status];
  }

  return (
    <Text tone={getTextTone(listing.status)} size="large">
      {listingStatus}
    </Text>
  );
};

type TextTone = React.ComponentProps<typeof Text>['tone'];

const getTextTone = (status: ListingStatus): TextTone => {
  switch (status) {
    case ListingStatus.Draft:
      return 'info';
    case ListingStatus.Pending:
      return 'promote';
    case ListingStatus.Active:
      return 'positive';
    case ListingStatus.Expired:
      return 'secondary';
  }
};
